import React, { useState } from 'react';
import { useAccount, useConnect, useDisconnect, useBalance, useChainId, useSwitchChain } from 'wagmi';
import './WalletConnect.css';

const WalletConnect = ({ inline = false }) => {
    const [showModal, setShowModal] = useState(false);
    const { address, isConnected, isConnecting } = useAccount();
    const { connectors, connect, error, isPending } = useConnect();
    const { disconnect } = useDisconnect();
    const chainId = useChainId();
    const { switchChain, chains } = useSwitchChain();
    
    const { data: balance } = useBalance({
        address: address,
    });

    const formatAddress = (addr) => {
        if (!addr) return '';
        return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
    };

    const formatBalance = (bal) => {
        if (!bal) return '0';
        return parseFloat(bal.formatted).toFixed(4);
    };

    const getChainName = (id) => {
        const chain = chains?.find(c => c.id === id);
        return chain?.name || 'Unknown';
    };

    const handleConnect = async (connector) => {
        try {
            await connect({ connector });
            setShowModal(false);
        } catch (err) {
            console.error('Connection error:', err);
        }
    };

    const handleDisconnect = () => {
        disconnect();
        setShowModal(false);
    };

    if (isConnected) {
        return (
            <div className={`wallet-connected ${inline ? 'inline' : ''}`}>
                <div className="wallet-info">
                    <div className="wallet-address" onClick={() => setShowModal(!showModal)}>
                        <span className="wallet-dot"></span>
                        <span>{formatAddress(address)}</span>
                    </div>
                    {balance && (
                        <div className="wallet-balance">
                            {formatBalance(balance)} {balance.symbol}
                        </div>
                    )}
                </div>
                
                {showModal && (
                    <div className="wallet-dropdown">
                        <div className="wallet-dropdown-header">
                            <span className="chain-name">{getChainName(chainId)}</span>
                        </div>
                        <div className="wallet-dropdown-address">
                            {address}
                        </div>
                        
                        <div className="wallet-dropdown-section">
                            <span className="section-title">Switch Network</span>
                            <div className="chain-list">
                                {chains?.map((chain) => (
                                    <button
                                        key={chain.id}
                                        className={`chain-btn ${chainId === chain.id ? 'active' : ''}`}
                                        onClick={() => switchChain({ chainId: chain.id })}
                                    >
                                        {chain.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                        
                        <button className="disconnect-btn" onClick={handleDisconnect}>
                            Disconnect
                        </button>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={`wallet-connect ${inline ? 'inline' : ''}`}>
            <button 
                className={`connect-wallet-btn ${inline ? 'inline-btn' : ''}`}
                onClick={() => setShowModal(true)}
                disabled={isConnecting}
            >
                {isConnecting ? 'Connecting...' : 'Connect Wallet'}
            </button>

            {showModal && (
                <div className="wallet-modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="wallet-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="wallet-modal-header">
                            <h3>Connect Wallet</h3>
                            <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        
                        <div className="wallet-modal-body">
                            {connectors.map((connector) => (
                                <button
                                    key={connector.uid}
                                    className="connector-btn"
                                    onClick={() => handleConnect(connector)}
                                    disabled={isPending}
                                >
                                    <span className="connector-name">{connector.name}</span>
                                    {isPending && <span className="connecting-text">Connecting...</span>}
                                </button>
                            ))}
                        </div>

                        {error && (
                            <div className="wallet-error">
                                {error.message}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default WalletConnect;

